export default __webpack_public_path__ + "static/media/08_Lori_berd.f01ac40a.webp";